export const INITIAL_SUB_PAGE = '';
//# sourceMappingURL=InitialMobileSubpage.js.map